import { showFlash, hideFlash } from './flash_show';
// Consent "settled" means CookieBot banner appeared and the user has made some choice (clicked "ok")
// Consent "given" means user has allowed cookies of a specific type.
// For best UX, only show the Cookie Consent Warning if consent has been settled.
// Make sure to hide Cookie Consent Warning when consent has been given to ensure it will disappear then the user changes their choice.
// To achieve that, use warnOrRunWhenConsentGiven from cookies_content_warning.
function isConsentSettled() {
    return !!(window.Cookiebot && window.Cookiebot.hasResponse && window.Cookiebot.consent);
}
function isConsentGiven(consentTypes) {
    return isConsentSettled() && consentTypes.every(type => window.Cookiebot.consent[type]);
}
function runWhenConsentGiven(consentTypes, callback) {
    if (isConsentGiven(consentTypes)) {
        callback();
        return;
    }
    window.addEventListener('CookiebotOnAccept', () => {
        if (isConsentGiven(consentTypes)) {
            callback();
        }
    }, false);
}
function runWhenConsentSettled(callback) {
    if (isConsentSettled()) {
        callback();
    }
    // 'CookiebotOnAccept' is triggered when at least 1 cookie type is accepted
    window.addEventListener('CookiebotOnAccept', () => {
        callback();
    }, false);
    window.addEventListener('CookiebotOnDecline', () => {
        callback();
    }, false);
}
function maybeShowCookiesConsentWarning(consentTypes, message) {
    if (isConsentSettled() && !isConsentGiven(consentTypes)) {
        showFlash('info', message);
    }
}
function warnOrRunWhenConsentGiven(cookieTypes, callback) {
    const message = window.steadyI18n.cookieConsentWarning;
    runWhenConsentSettled(function () {
        maybeShowCookiesConsentWarning(cookieTypes, message);
    });
    runWhenConsentGiven(cookieTypes, function () {
        hideFlash('info', message);
        if (typeof callback === 'function') {
            callback();
        }
    });
}
export default {
    runWhenConsentGiven,
    runWhenConsentSettled,
    isConsentGiven,
    isConsentSettled,
    warnOrRunWhenConsentGiven
};
